import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import DossierDocuments from './DossierDocuments';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class CostCenterShow extends Component {
    constructor(props) {
        super();
        this.state = {
            costCenter:[],
            active:true,
            targets:[],
            search:'',
            targets:[],
            name:'',
            users:[],
            selectedUsers:[]
        };
        this.getInitials = this.getInitials.bind(this)
    }

    async componentDidMount() {
        await axios.get('/api/cost_centers/'+this.props.id).then(res=>{
            this.setState({ costCenter: res.data} );
            this.setState({ name: res.data.name} );
        })
        await this.getTargets()
        let selected = this.state.costCenter.user_cost_center.map((u)=>{
            u.user.userId = u.user.id
            return u
        })
        this.setState({ selectedUsers: selected} );
    }

    handleCheck(id){
        let checked = false;
        this.state.costCenter.cost_center_dossier_targets.map(function(dossierTarget){
            if(dossierTarget.dossier_target_id == id){
                checked = true
            }
            if(dossierTarget.id == id){
                checked = true
            }
        })
        return checked;
    }

    getInitials(name){
        const nameList = name.split(' ')
        return nameList.length >= 2 ? `${nameList[0][0]}${nameList[1][0]}` : nameList[0][0]
    }

    async getTargets() {
        const res = await axios.get('/api/dossiers/targets/all')
        this.setState({targets: res.data})
    }

    render() {
        return (
            <form id="frm">
                <div class="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div class="d-flex align-items-center flex-wrap mr-1">
                        <div class="d-flex align-items-baseline flex-wrap mr-5">
                            <h5 class="text-dark font-weight-bold my-1 mr-5">
                                Información del Centro de Costos
                            </h5>
                        </div>
                    </div>
                </div>
                <div className="container subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div class="col-sm-6 form-group">
                        <div><strong>Nombre del centro de costos</strong></div>
                        <div class="text-dark-50"> {this.state.name}</div>
                    </div>
                    <div class="col-sm-6 form-group">
                    <label htmlFor="dossier_targets_id " className="text-left">Centro de costos para</label>
                            <div className="checkbox-inline">
                                {   this.state.targets.map(( mime) => {
                                    return(
                                        < >
                                            {this.handleCheck(mime.id,mime.name) &&
                                            <div className="mr-8" key={mime.id} >
                                                <span class="svg-icon svg-icon-primary svg-icon-2x"><svg xmlns="http://www.w3.org/2000/svg"   width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                        <polygon points="0 0 24 0 24 24 0 24"/>
                                                        <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fill-rule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
                                                    </g>
                                                </svg> </span>
                                                {mime.name}
                                                </div>
                                            }
                                            {!this.handleCheck(mime.id,mime.name) &&
                                                <div className="text-dark-50 mr-8" key={mime.id} >
                                                    {mime.name}
                                                </div>
                                            }
                                        </ >
                                    )
                                })}
                            </div>
                    </div>
                </div>
                <div className="d-flex flex-column-fluid">
                    <div className="container">
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <table className="table table-borderless table-vertical-center">
                                    <thead>
                                        <tr className="b-bottom">
                                            <td colSpan="2">Usuario</td>
                                            <td>Perfil</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.selectedUsers.map((u) => {
                                        return(
                                            <tr key={u.user.userId}>
                                                <td style={{width: '1%'}}>
                                                    <div className="symbol symbol-40">
                                                        <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                                                            {this.getInitials(u.user.name)}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-dark-75 font-weight-bolder font-size-lg"> {u.user.name}</div>
                                                    <span className="text-dark-50 font-weight-bold font-size-sm"> {u.user.email}</span>
                                                </td>
                                                <td>
                                                    {u.profiles.map((p,i,arr) => {
                                                        if (arr.length - 1 === i) {
                                                            return p.people_profile.name
                                                        } else {
                                                            return p.people_profile.name + ', '
                                                        }
                                                    })}
                                                </td>

                                            </tr>
                                            )
                                        })}
                                        <tr>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default CostCenterShow;

if (document.getElementById('CostCenterShow')) {
    ReactDOM.render(<CostCenterShow />, document.getElementById('CostCenterShow'));
}
